<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    hide-overlay
    :max-width="$vuetify.breakpoint.smAndDown ? '100%' : '60%'"
    transition="dialog-bottom-transition"
  >
    <!-- <v-dialog v-model="show" z-index="2000" transition="dialog-top-transition" max-width="600"> -->
    <v-card v-if="content !== null">
      <v-toolbar
        flat
        class="tool-bar"
        style="background-color:rgba(0,0,0,.0); position: absolute; z-index:145; width:100%"
      >
        <v-btn fab small color="white" @click="onClose()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title></v-toolbar-title>
      </v-toolbar>
      <v-img
        style="filter: blur(5px);position:absolute"
        gradient="to top, rgba(0,0,0,.53), rgba(25,32,72,.2)"
        :src="imageURL"
        width="100%"
        max-height="350px"
      />

      <v-img contain width="100%" max-height="350px" :src="imageURL" />

      <v-card-text class="mt-3">
        <h6 class="pt-3 px-4">{{ content.subtitle }}</h6>
        <div class="body-2 mt-4">
          {{ content.description }}
        </div>
        <br />
        <span>Leer más:</span><br />
        <a target="_blank" :href="content.link" v-text="content.link" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import $ from "jquery";
export default {
  name: "Overlay-Vinculacion",
  data: () => ({
    publicPath: $(location).attr("origin") + "/archivos/vinculacion/",
  }),
  computed: {
    imageURL: function() {
      return this.publicPath + this.content.image;
    }
  },
  props: {
    show: Boolean,
    onClose: Function,
    content: Object
  },
  watch: {
    content: function(value) {
      // console.warn(value);
    }
  }
};
</script>
<style lang="scss">
.v-overlay {
  z-index: 2000 !important;
}
</style>
<style lang="scss" scoped>
@import "@/assets/styles/global";
h6 {
  border-left: $green solid 4px;
  padding-left: 5px;
}
.v-dialog__content {
  z-index: 2010 !important;
}
</style>

<!-- ////////////////////////////////////////////////////////// -->
